import { BoxProps } from "@mui/material"
import React from "react"
import { useMediaQuery } from "react-responsive"

import { Box, Container, Typography } from "src/UILibrary"

type Props = {
  sx?: BoxProps
  steps: string[]
  current: number
}

const Stepper = ({ sx, steps, current }: Props) => {
  const isPC = useMediaQuery({ query: "(min-width: 550px)" })

  const style = sx || {}
  return (
    <Container
      sx={{
        height: "60px",
        display: "flex",
        mx: "auto",
        width: "100%",
        ...style,
      }}
    >
      <Box
        height="100%"
        sx={{
          mx: "auto",
          display: "flex",
          overflowX: isPC ? "none" : "scroll",
          padding: "5px",
          scrollbarWidth: "none",
        }}
      >
        {steps.map((step: string, index: number) => {
          return (
            <Box
              key={index}
              display="flex"
              position="relative"
              // width={`${100 / steps.length}%`}
              minWidth="150px"
              sx={
                index + 1 <= current
                  ? {
                      borderBottomStyle: "solid",
                      borderBottomColor: "primary.main",
                      borderBottomWidth: 1,
                      scrollbarWidth: "none",
                    }
                  : {
                      borderBottomStyle: "dashed",
                      borderBottomColor: "text.disabled",
                      borderBottomWidth: 1,
                      scrollbarWidth: "none",
                    }
              }
            >
              <Typography.Stepper
                sx={
                  index + 1 <= current
                    ? {
                        fontFamily: "Noto Sans JP !important",
                        color: "primary.main",
                        mx: "auto",
                        my: "15px",
                      }
                    : {
                        fontFamily: "Noto Sans JP !important",
                        color: "text.disabled",
                        mx: "auto",
                        my: "15px",
                      }
                }
              >
                {step}
              </Typography.Stepper>
              {index === 0 && (
                <Box
                  sx={{
                    position: "absolute",
                    left: 0,
                    top: 46,
                    width: 7,
                    height: 7,
                    borderRadius: 7,
                    backgroundColor: "primary.main",
                  }}
                ></Box>
              )}
              {index === steps.length - 1 && (
                <Box
                  sx={
                    current === steps.length
                      ? {
                          position: "absolute",
                          right: 0,
                          top: 46,
                          width: 7,
                          height: 7,
                          borderRadius: 7,
                          backgroundColor: "primary.main",
                        }
                      : {
                          position: "absolute",
                          right: 0,
                          top: 46,
                          width: 7,
                          height: 7,
                          borderRadius: 7,
                          backgroundColor: "text.disabled",
                        }
                  }
                ></Box>
              )}
            </Box>
          )
        })}
      </Box>
    </Container>
  )
}

export default Stepper
